export const TOAST_ALERT_BALANCE_TIMESTAMP = 'AlertBalanceToastTimestamp';
